import { CommonModule } from '@angular/common';
import {
  CUSTOM_ELEMENTS_SCHEMA,
  NO_ERRORS_SCHEMA,
  NgModule,
} from '@angular/core';
import { GoogleMapsModule } from '@angular/google-maps';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatToolbarModule } from '@angular/material/toolbar';
import { CarouselDocumentsComponent } from './carousel-documents/carousel-documents.component';
import { ConfirmationComponent } from './confirmation/confirmation.component';
import { CountrySelectionComponent } from './country-selection/country-selection.component';
import { InputOverviewDirective } from './directives/input-overview.directive';
import { NumberDirective } from './directives/number.directive';
import { MapComponent } from './map/map.component';
import { PrivacyTermsComponent } from './privacy-terms/privacy-terms.component';
import { RequestInformationComponent } from './request-information/request-information.component';
import { BlockCopyPasteInputDirective } from './directives/block-copy-paste-input.directive';
import { CollapsedStepsDirective } from './directives/collapsed-steps.directive';
import { CameraComponent } from './camera/camera.component';

@NgModule({
  declarations: [
    RequestInformationComponent,
    ConfirmationComponent,
    PrivacyTermsComponent,
    MapComponent,
    NumberDirective,
    InputOverviewDirective,
    CountrySelectionComponent,
    CarouselDocumentsComponent,
    BlockCopyPasteInputDirective,
    CollapsedStepsDirective,
    CameraComponent
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    MatToolbarModule,
    MatButtonModule,
    GoogleMapsModule,
    MatIconModule,
  ],
  exports: [
    NumberDirective,
    InputOverviewDirective,
    BlockCopyPasteInputDirective,
    CollapsedStepsDirective,
    CameraComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class SharedModule {}
